<div class="language-switcher">
  <button
    type="button"
    class="language-trigger"
    [attr.aria-label]="'language.switcherLabel' | translate"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="listbox"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)"
  >
    <span class="active-locale-label">{{ activeLabel() }}</span>
    <span class="dropdown-arrow" aria-hidden="true">▾</span>
  </button>

  @if (isOpen()) {
    <ul
      class="language-dropdown"
      role="listbox"
      [attr.aria-label]="'language.switcherLabel' | translate"
      (keydown)="onListKeydown($event)"
    >
      @for (option of localeOptions; track option.code; let i = $index) {
        <li
          role="option"
          class="language-option"
          [class.focused]="focusedIndex() === i"
          [class.active]="option.code === activeLocale()"
          [attr.aria-selected]="option.code === activeLocale()"
          [id]="'locale-option-' + option.code"
          (click)="selectLocale(option.code)"
        >
          {{ option.label }}
        </li>
      }
    </ul>
  }

  @if (errorMessage()) {
    <div class="language-error" role="alert">
      {{ errorMessage() }}
    </div>
  }
</div>
